'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pizza = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Pizza, _Component);

  function Pizza() {
    (0, _classCallCheck3.default)(this, Pizza);
    return (0, _possibleConstructorReturn3.default)(this, (Pizza.__proto__ || (0, _getPrototypeOf2.default)(Pizza)).apply(this, arguments));
  }

  (0, _createClass3.default)(Pizza, [{
    key: 'render',
    value: function render() {
      var styles = require('./Recipes.scss');
      var pizzaImg = require('./Assets/pizza.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.recipePanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Pizza People'
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12 },
              _react2.default.createElement(ReactBootstrap.Col, { md: 2 }),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 8 },
                _react2.default.createElement(ReactBootstrap.Image, { src: pizzaImg, responsive: true })
              ),
              _react2.default.createElement(ReactBootstrap.Col, { md: 2 })
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12 },
              _react2.default.createElement(
                'p',
                null,
                'Makes 6 small pizzas!'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Ingredients:'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '6 mini Lebanese bread circles or 2 large Lebanese bread circle'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1/2 cup crushed tomatoes'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1/3 cup cheese, grated (e.g. mozzarella or tasty, preferably low fat)'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 cup mixed vegetables, e.g. sliced mushrooms, zucchini, olives, capsicum, cherry tomatoes, etc.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12 },
              _react2.default.createElement(
                'p',
                null,
                'Instructions:'
              ),
              _react2.default.createElement(
                'ol',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  'Preheat oven to 200 degrees Celsius, fan forced. Prepare a baking tray lined with baking paper and place Lebanese bread circles on top.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Spread bases with crushed tomatoes and sprinkle with cheese.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Arrange vegetables on top of bases to look like faces.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Bake for 5-10 minutes [until golden and crispy].'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'Pizza people can be frozen for up to 3 months and thawed in a fridge or reheated in an oven.'
              )
            )
          )
        )
      );
    }
  }]);
  return Pizza;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp)) || _class);
exports.default = Pizza;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Pizza.js
// module id = 1231
// module chunks = 0